// Get the testnet deployment flag
const IS_TESTNET_DEPLOYMENT = process.env.REACT_APP_IS_TESTNET_DEPLOYMENT === 'true'

export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL || '[Error: URL not found]'
export const MILES_SERVER_URL = process.env.REACT_APP_MILES_SERVER_URL
export const MILES_SERVER_V2_URL = process.env.REACT_APP_MILES_SERVER_V2_URL
export const ANCHOR_PROVIDER_URL = process.env.REACT_APP_ANCHOR_PROVIDER_URL || '[Error: URL not found]'
export const ANCHOR_PROVIDER_URL_FALLBACK =
    process.env.REACT_APP_ANCHOR_PROVIDER_URL_FALLBACK || '[Error: URL not found]'

export const CACHE_HALF_FULL_URL_TESTNET = process.env.REACT_APP_CACHE_HALF_FULL_URL_TESTNET

// Use testnet URLs when IS_TESTNET_DEPLOYMENT is true
export const CACHE_HALF_FULL_URL = IS_TESTNET_DEPLOYMENT
    ? process.env.REACT_APP_CACHE_HALF_FULL_URL_TESTNET
    : process.env.REACT_APP_CACHE_HALF_FULL_URL

// Use testnet pricing API when IS_TESTNET_DEPLOYMENT is true
export const MACHPROTOCOL_API_URL = IS_TESTNET_DEPLOYMENT
    ? process.env.REACT_APP_PRICE_API_URL_TESTNET
    : process.env.REACT_APP_PRICE_API_URL
export const ASSET_API_V2_URL = process.env.REACT_APP_ASSET_API_V2_URL
export const REACT_APP_PRICE_API_URL_TESTNET = process.env.REACT_APP_PRICE_API_URL_TESTNET
